import React, { useState, useEffect } from 'react';
import { TextField, Button, Typography, Box } from '@mui/material';
import axios from 'axios';

const UserProfile = () => {
  const [profileData, setProfileData] = useState({
    firstname: "",
    lastname: "",
    email: "",
    phone: "",
    user_type: "" // Add user_type to handle user role
  });

  useEffect(() => {
    // Fetch initial profile data for user_id = 1
    axios.get('http://localhost:3001/user/profile')
      .then(response => {
        setProfileData(response.data);
      })
      .catch(error => {
        console.error('Error fetching profile data:', error);
      });
  }, []);

  const handleChange = (event) => {
    const { name, value } = event.target;
    setProfileData((prevData) => ({ ...prevData, [name]: value }));
  };

  const handleSave = () => {
    axios.put('http://localhost:3001/user/profile', profileData)
      .then(response => {
        alert(response.data.message);
      })
      .catch(error => {
        console.error('Error updating profile:', error);
        alert('Failed to update profile');
      });
  };

  return (
    <Box sx={{ padding: '2rem' }}>
      <Typography variant="h4" gutterBottom>Edit Profile</Typography>
      <TextField
        label="First Name"
        name="firstname"
        value={profileData.firstname}
        onChange={handleChange}
        fullWidth
        margin="normal"
      />
      <TextField
        label="Last Name"
        name="lastname"
        value={profileData.lastname}
        onChange={handleChange}
        fullWidth
        margin="normal"
      />
      <TextField
        label="Email"
        name="email"
        value={profileData.email}
        onChange={handleChange}
        fullWidth
        margin="normal"
      />
      <TextField
        label="Phone"
        name="phone"
        value={profileData.phone}
        onChange={handleChange}
        fullWidth
        margin="normal"
      />
      <TextField
        label="User Type"
        name="user_type"
        value={profileData.user_type}
        onChange={handleChange}
        fullWidth
        margin="normal"
      />
      <Button onClick={handleSave} variant="contained" color="primary">Save</Button>
    </Box>
  );
};

export default UserProfile;